/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var MultiColumnComboBoxTextChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBoxTextChangedEventArgs, _super);
    function MultiColumnComboBoxTextChangedEventArgs(a, b) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.b = null;
        _this.d = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(MultiColumnComboBoxTextChangedEventArgs.prototype, "oldText", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxTextChangedEventArgs.prototype, "newText", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboBoxTextChangedEventArgs.$t = markType(MultiColumnComboBoxTextChangedEventArgs, 'MultiColumnComboBoxTextChangedEventArgs', EventArgs.$);
    return MultiColumnComboBoxTextChangedEventArgs;
}(EventArgs));
export { MultiColumnComboBoxTextChangedEventArgs };
//# sourceMappingURL=MultiColumnComboBoxTextChangedEventArgs.js.map
